import {Component, h, Prop} from '@stencil/core';

@Component({
    tag: 'expired-cart-template',
    styleUrl: 'style.sass',
    shadow: true,
})
export class ExpiredCartTemplate {
    @Prop() titleText: string;
    @Prop() hintText: string;

    render() {
        return (
            <div class="EmptyContainer">
                <rentware-spacer size="XL" />

                <svg width="112" height="54" viewBox="0 0 112 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="7" y="2" width="98.8235" height="48" rx="10" fill="#46435B" />
                    <rect x="10.0588" y="5" width="92.7059" height="42" rx="7" stroke="#2E2D37" stroke-width="2" />
                    <rect width="4" height="16" transform="matrix(-1 0 0 1 111 18)" fill="#2E2D37" />
                    <rect width="8" height="2" transform="matrix(-1 0 0 1 26.1177 52)" fill="#2E2D37" />
                    <rect width="8" height="2" transform="matrix(-1 0 0 1 95.1177 52)" fill="#2E2D37" />
                    <ellipse cx="56.4118" cy="21" rx="2.05882" ry="2" fill="#E2E2E6" />
                    <ellipse cx="56.4118" cy="31" rx="2.05882" ry="2" fill="#E2E2E6" />
                    <path d="M31.706 26V13C31.706 12.4477 31.2582 12 30.706 12H18.2942C17.7419 12 17.2942 12.4477 17.2942 13V26M31.706 26V39C31.706 39.5523 31.2582 40 30.706 40H18.2942C17.7419 40 17.2942 39.5523 17.2942 39V26M31.706 26H17.2942" stroke="#2E2D37" />
                    <rect x="21.4119" y="18" width="6.17647" height="16" rx="3" stroke="#D0D0D6" stroke-width="3" />
                    <path d="M19.8677 26H22.9559" stroke="#B5B4BD" />
                    <path d="M26.0442 26H29.1324" stroke="#B5B4BD" />
                    <rect width="1.02941" height="4" transform="matrix(-1 0 0 1 18.3235 24)" fill="#2E2D37" />
                    <rect width="1.02941" height="4" transform="matrix(-1 0 0 1 31.7058 24)" fill="#2E2D37" />
                    <path d="M50.2353 26V13C50.2353 12.4477 49.7875 12 49.2353 12H36.8235C36.2712 12 35.8235 12.4477 35.8235 13V26M50.2353 26V39C50.2353 39.5523 49.7875 40 49.2353 40H36.8235C36.2712 40 35.8235 39.5523 35.8235 39V26M50.2353 26H35.8235" stroke="#2E2D37" />
                    <rect x="39.9412" y="18" width="6.17647" height="16" rx="3" stroke="#D0D0D6" stroke-width="3" />
                    <path d="M38.397 26H41.4852" stroke="#B5B4BD" />
                    <path d="M44.5735 26H47.6617" stroke="#B5B4BD" />
                    <rect width="1.02941" height="4" transform="matrix(-1 0 0 1 36.853 24)" fill="#2E2D37" />
                    <rect width="1.02941" height="4" transform="matrix(-1 0 0 1 50.2354 24)" fill="#2E2D37" />
                    <path d="M76.9999 26V13C76.9999 12.4477 76.5522 12 75.9999 12H63.5881C63.0359 12 62.5881 12.4477 62.5881 13V26M76.9999 26V39C76.9999 39.5523 76.5522 40 75.9999 40H63.5881C63.0358 40 62.5881 39.5523 62.5881 39V26M76.9999 26H62.5881" stroke="#2E2D37" />
                    <rect x="66.7058" y="18" width="6.17647" height="16" rx="3" stroke="#D0D0D6" stroke-width="3" />
                    <path d="M65.1619 26H68.2501" stroke="#B5B4BD" />
                    <path d="M71.3381 26H74.4264" stroke="#B5B4BD" />
                    <rect width="1.02941" height="4" transform="matrix(-1 0 0 1 63.6177 24)" fill="#2E2D37" />
                    <rect width="1.02941" height="4" transform="matrix(-1 0 0 1 77 24)" fill="#2E2D37" />
                    <path d="M95.5294 26V13C95.5294 12.4477 95.0817 12 94.5294 12H82.1177C81.5654 12 81.1177 12.4477 81.1177 13V26M95.5294 26V39C95.5294 39.5523 95.0817 40 94.5294 40H82.1177C81.5654 40 81.1177 39.5523 81.1177 39V26M95.5294 26H81.1177" stroke="#2E2D37" />
                    <rect x="85.2354" y="18" width="6.17647" height="16" rx="3" stroke="#D0D0D6" stroke-width="3" />
                    <path d="M83.6912 26H86.7794" stroke="#B5B4BD" />
                    <path d="M89.8677 26H92.9559" stroke="#B5B4BD" />
                    <rect width="1.02941" height="4" transform="matrix(-1 0 0 1 82.147 24)" fill="#2E2D37" />
                    <rect width="1.02941" height="4" transform="matrix(-1 0 0 1 95.5293 24)" fill="#2E2D37" />
                    <path opacity="0.2" d="M7 12C7 6.47715 11.4772 2 17 2H66.7059L46.1176 50H17C11.4771 50 7 45.5228 7 40V12Z" fill="url(#paint0_linear)" />
                    <rect x="7" y="2" width="98.8235" height="48" rx="10" stroke="url(#paint1_linear)" stroke-width="4" />
                    <defs>
                        <linearGradient id="paint0_linear" x1="36.8529" y1="2" x2="36.8529" y2="50" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F0F0F2" />
                            <stop offset="1" stop-color="#F0F0F2" stop-opacity="0" />
                        </linearGradient>
                        <linearGradient id="paint1_linear" x1="3.1171" y1="54.704" x2="134.648" y2="22.2425" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#00EECC" />
                            <stop offset="1" stop-color="#BB00EE" />
                        </linearGradient>
                    </defs>
                </svg>

                <rentware-spacer size="S" />

                <p class="EmptyTitle">
                    {this.titleText}
                </p>

                <p>
                    {this.hintText}
                </p>

                <rentware-spacer size="L" />
            </div>
        )
    }
}
